"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelperText = void 0;

require("core-js/modules/es.number.constructor.js");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HelperText = function HelperText(props) {
  var helperText = props.helperText,
      hasMaxLength = props.hasMaxLength,
      maxLength = props.maxLength,
      value = props.value,
      required = props.required;
  var length = Number(value === null || value === void 0 ? void 0 : value.length) || 0;
  var innerHelperText = Boolean(helperText && required) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "*", helperText) : helperText;
  return hasMaxLength ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, innerHelperText), /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": "counter"
  }, length, "/", maxLength)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, innerHelperText);
};

exports.HelperText = HelperText;